var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "operations-table" },
    [
      _c("horizontal-table", [
        _c(
          "table",
          { staticClass: "h-table" },
          _vm._l(_vm.columns, function (column) {
            return _c(
              "tr",
              { key: column.id },
              [
                _c(
                  "th",
                  {
                    staticClass: "h-table__col-title",
                    class: {
                      active: _vm.sortBy === column.sort,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.sort(column.sort)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(column.titleSm || column.title) + " ")]
                ),
                _vm._l(_vm.dates, function (date) {
                  return [
                    date.resume
                      ? [
                          _c("cell", {
                            key: date.unique,
                            attrs: {
                              column: column,
                              date: date,
                              edit: _vm.edit,
                            },
                            on: {
                              toggle: function ($event) {
                                date.open = !date.open
                              },
                            },
                          }),
                        ]
                      : _vm._e(),
                    !date.resume || date.open
                      ? _vm._l(date.operations, function (operation) {
                          return _c("cell", {
                            key: operation.unique,
                            attrs: {
                              column: column,
                              date: date,
                              operation: operation,
                              edit: _vm.edit,
                              "can-remove": _vm.canRemove,
                            },
                            on: {
                              remove: function ($event) {
                                return _vm.remove(operation)
                              },
                              restore: function ($event) {
                                return _vm.restore(operation)
                              },
                            },
                          })
                        })
                      : _vm._e(),
                  ]
                }),
              ],
              2
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }